import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CommonDataModel } from 'src/app/shared/common-data-model';

@Component({
    selector: 'app-popup-dialog-with-dropdown',
    templateUrl: './popup-dialog-with-dropdown.component.html',
    styleUrls: ['./popup-dialog-with-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PopupDialogWithDropdownComponent implements OnInit {

    commonDataModel = new CommonDataModel();
    confirmButton = false;
    dailogData: any;
    selectedItem = this.commonDataModel.dropdownDatModel;
    itemList: any = [];
    copiedItemList: any = [];
    rfqRejection = true;

    constructor(
        private dialogRef: MatDialogRef<PopupDialogWithDropdownComponent>,
        @Inject(MAT_DIALOG_DATA) dailogData?: any) {
        this.dailogData = dailogData;
        this.itemList = dailogData.dropDownData.map((item: {
            id: { toString: () => any; };
            reasons: { toString: () => any; };
        }) => Object.assign(item, { id: item.id, name: item.reasons }));
        this.copiedItemList = this.itemList;
    }

    ngOnInit() {
    }

    onConfirm() {
        this.confirmButton = true;
        this.dialogRef.close({ confirmResult: this.confirmButton, rfqRejection: this.rfqRejection, itemInfo: this.selectedItem });
    }

    onClose(value: any) {
        this.confirmButton = value;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

    onItemChange(item: any) {
        this.selectedItem = item;
    }

    onSearchChange(value: any) {
        if (value !== '' && typeof value !== 'object') {
            this.itemList = this.copiedItemList.filter((s) =>
                s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        } else if (value === '') {
            this.selectedItem = this.commonDataModel.dropdownDatModel;
            this.itemList = this.copiedItemList;
        }
    }
}
